import { render, staticRenderFns } from "./SwitchAccounts.vue?vue&type=template&id=9cd8d1e8&scoped=true&"
import script from "./SwitchAccounts.vue?vue&type=script&lang=ts&"
export * from "./SwitchAccounts.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchAccounts.vue?vue&type=style&index=0&id=9cd8d1e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd8d1e8",
  null
  
)

component.options.__file = "SwitchAccounts.vue"
export default component.exports